import { render, staticRenderFns } from "./notFoundView.vue?vue&type=template&id=ca910d9e"
import script from "./notFoundView.vue?vue&type=script&lang=ts"
export * from "./notFoundView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports